import React, { useEffect, useState } from "react";
import NavbarTop from "./NavbarTop";
import {
  Badge,
  Button,
  Card,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  Nav,
  NavItem,
  Row,
  NavLink,
} from "reactstrap";

import Select from "react-select";
import { countries } from "../Utils/countries";
import Datetime from "react-datetime";
import axios from "axios";

const Donate = () => {
  const [pills, setPills] = useState("1");
  const [name, setName] = useState("");
  const [dob, setDob] = useState(new Date());
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [amount, setAmount] = useState(500);
  const [phone, setPhone] = useState("");
  const [zip, setZip] = useState("");
  const [address, setAddress] = useState("");
  const [pan, setPan] = useState("");
  const [email, setEmail] = useState("");
  const [passport, setPassport] = useState(null);
  const [allStates, setAllStates] = useState([]);
  const [allCountry, setAllCountry] = useState([]);

  useEffect(() => {
    countries.forEach((item) => {
      if (item.name === country.value) {
        const states = getAllStates(item);
        setAllStates(states);
      }
    });
  }, [country]);

  useEffect(() => {
    const countryArray = [];
    countries.forEach((item, index) => {
      countryArray.push({ value: item.name, label: item.name });
    });
    setAllCountry(countryArray);
  }, []);

  const getAllStates = (data) => {
    const states = [];
    data.states.forEach((item) => {
      states.push({ value: item.name, label: item.name });
    });
    return states;
  };

  const submitHandler = async () => {
    if (pills === "1" || passport !== null) {
      const formData = new FormData();
      formData.append("donate_form[full_name]", name);
      formData.append("donate_form[email]", email);
      formData.append(
        "donate_form[dob]",
        `${dob.getDate()}/${dob.getMonth() + 1}/${dob.getFullYear()}`
      );
      formData.append("donate_form[city]", city);
      formData.append("donate_form[state]", state.value);
      formData.append("donate_form[country]", country.value);
      formData.append("donate_form[support_amount]", amount);
      formData.append("donate_form[address]", address);
      formData.append("donate_form[postalCode]", zip);
      if (pills === "1") {
        formData.append("donate_form[pancard]", pan);
        formData.append("donate_form[donator_type]", "indian");
        formData.append("donate_form[phone_no]", `91${phone}`);
      } else {
        formData.append("donate_form[passport]", passport, passport.name);
        formData.append("donate_form[donator_type]", "foreign");
      }
      const response = await axios.post(
        `https://swatch-v1.herokuapp.com/api/v1/donate_forms`,
        formData
      );
      console.log(response);
      if (response.status === 200) {
        alert("Form submitted successfully !");
      } else {
        alert("Error in submitting form! Try again later.");
      }
    }
  };

  const NavPills = () => {
    return (
      <Nav className="nav-pills-danger" pills role="tablist">
        <NavItem>
          <NavLink
            className={pills === "1" ? "active" : ""}
            onClick={() => setPills("1")}
            role="tablist"
          >
            INDIAN
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={pills === "2" ? "active" : ""}
            onClick={() => setPills("2")}
          >
            FOREIGN
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  return (
    <>
      <NavbarTop staticColor={"true"} />
      <div className="wrapper">
        <div className="main">
          <div className="section section-white">
            <Container>
              <Row>
                <Col className="ml-auto mr-auto text-center title" md="6">
                  <h2>Donate</h2>
                  <h3 className="title-uppercase">
                    <small>Help Svastha in acheiving the goal</small>
                  </h3>
                </Col>
              </Row>
              {/*<Row>*/}
              {/*  <Col className="ml-auto mr-auto" md="8">*/}
              {/*    <div className="article-content">*/}
              {/*      <h4>DIRECT BANK TRANSFER</h4>*/}
              {/*      <p>*/}
              {/*        <br/>*/}
              {/*        Thank you for your kindness!*/}
              {/*        <br/>*/}
              {/*        <br/>*/}
              {/*        You could make your donation via direct bank transfer in an easy and safe way.*/}
              {/*        <br/>*/}
              {/*        <br/>*/}
              {/*        <strong>Our bank details are:</strong>*/}
              {/*        <br/>*/}
              {/*        <br/>*/}
              {/*        <strong>The Akshaya Patra Foundation UK</strong>*/}
              {/*        <br/>*/}
              {/*        HSBC Bank PLC*/}
              {/*        <br/>*/}
              {/*        Account no: 31741349*/}
              {/*        <br/>*/}
              {/*        Sort Code: 40-38-18*/}
              {/*        <br/><br/>*/}
              {/*        IMPORTANT: Please kindly remember to drop us a note on office@tapf.org.uk with your name and email address so that we can send you a receipt. This will help you and us keep a record. If you wish for us to use your donation to a particular charity programme in India or UK - please let us know. If you pay taxes in the UK then your donation is eligible to for a gift aid claim. If you let us know, we can claim a little extra for the charity at no extra cost to you.*/}
              {/*        <br/><br/>*/}
              {/*        You may ring us on 020 80048741/45 for any other clarifications.*/}
              {/*        <br/><br/>*/}
              {/*        Regular receipts will be sent to you via email or post.*/}
              {/*        <br/><br/>*/}
              {/*        Thank you.*/}
              {/*      </p>*/}
              {/*    </div>*/}
              {/*  </Col>*/}
              {/*</Row>*/}
              <div className="main">
                <div className="section">
                  <Container>
                    <div>
                      <Row>
                        <Col md="5" sm="5">
                          <h3>Donate And Save Lives</h3>
                          <br />
                          <br />
                          <p>
                            The second wave of COVID – 19 is raging across India
                            with devastating impact. With more than 2.7 million
                            active cases as of May 25, 2021, our health
                            infrastructure is already overwhelmed. There is a
                            dire need for hospital beds, medicines consumables
                            and COVID appropriate behaviour among citizens.
                            <br />
                            <br />
                            Jansvastha with its experience in providing relief
                            during disasters and delivering large scale health
                            programmes on the ground, is well-positioned to
                            support the affected citizens where the need is the
                            greatest.
                            <br />
                            <br />
                            Today we need to come together to fight the COVID –
                            19 crisis and save lives.
                          </p>
                        </Col>
                        <Col md="7" sm="7">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              marginBottom: "50px",
                            }}
                          >
                            <NavPills />
                          </div>
                          <FormGroup>
                            <h6>
                              Full Name <span className="icon-danger">*</span>
                            </h6>
                            <Input
                              className="border-input"
                              placeholder="Enter full name here..."
                              type="text"
                              value={name}
                              onChange={(event) => setName(event.target.value)}
                            />
                          </FormGroup>
                          <Row className="price-row mt-1">
                            <Col md="6">
                              <h6>
                                Email <span className="icon-danger">*</span>
                              </h6>
                              <Input
                                className="border-input"
                                defaultValue=""
                                placeholder="Enter email"
                                type="text"
                                value={email}
                                onChange={(event) =>
                                  setEmail(event.target.value)
                                }
                              />
                            </Col>
                            <Col md="6">
                              <h6>
                                Phone Number{" "}
                                <span className="icon-danger">*</span>
                              </h6>
                              <Input
                                className="border-input"
                                defaultValue=""
                                placeholder="Enter phone number"
                                type="text"
                                value={phone}
                                onChange={(event) =>
                                  setPhone(event.target.value)
                                }
                              />
                            </Col>
                          </Row>
                          <Row className="price-row mt-3">
                            <Col md="6">
                              <h6>
                                DOB <span className="icon-danger">*</span>
                              </h6>
                              <FormGroup>
                                <InputGroup
                                  className="date"
                                  id="datetimepicker"
                                >
                                  <Datetime
                                    inputProps={{
                                      className: "form-control",
                                      placeholder: "Select your DOB",
                                      value: `${dob.getDate()}/${
                                        dob.getMonth() + 1
                                      }/${dob.getFullYear()}`,
                                    }}
                                    onChange={(moment) => {
                                      console.log(moment.toDate());
                                      setDob(moment.toDate());
                                    }}
                                  />
                                  <InputGroupAddon addonType="append">
                                    <InputGroupText>
                                      <span className="glyphicon glyphicon-calendar">
                                        <i className="fa fa-calendar" />
                                      </span>
                                    </InputGroupText>
                                  </InputGroupAddon>
                                </InputGroup>
                              </FormGroup>
                            </Col>
                            {pills === "1" ? (
                              <Col md="6">
                                <h6>
                                  Pan Card Number{" "}
                                  <span className="icon-danger">*</span>
                                </h6>
                                <Input
                                  className="border-input"
                                  defaultValue=""
                                  placeholder="Enter pan card number"
                                  type="text"
                                  value={pan}
                                  onChange={(event) =>
                                    setPan(event.target.value)
                                  }
                                />
                              </Col>
                            ) : (
                              <Col md="6">
                                <h6>
                                  Upload Passport{" "}
                                  <span className="icon-danger">*</span>
                                </h6>
                                <FormGroup>
                                  <Input
                                    className="border-input"
                                    defaultValue=""
                                    placeholder="Enter pan card number"
                                    type="file"
                                    accept={"image/*"}
                                    value={passport}
                                    onChange={(event) =>
                                      setPassport(event.target.files[0])
                                    }
                                  />
                                </FormGroup>
                              </Col>
                            )}
                          </Row>
                          <Row className="price-row">
                            <Col md="6">
                              <h6>
                                Address <span className="icon-danger">*</span>
                              </h6>
                              <Input
                                className="border-input"
                                defaultValue=""
                                placeholder="Enter address"
                                type="text"
                                value={address}
                                onChange={(event) =>
                                  setAddress(event.target.value)
                                }
                              />
                            </Col>
                            <Col md="6" sm="6">
                              <h6>
                                Country <span className="icon-danger">*</span>
                              </h6>
                              <FormGroup>
                                <Select
                                  className="react-select react-select-default"
                                  classNamePrefix="react-select"
                                  name="colorSelect"
                                  options={allCountry}
                                  placeholder="Select Country"
                                  value={country}
                                  onChange={(selected) => setCountry(selected)}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row className="price-row">
                            <Col md="6" sm="6">
                              <h6>
                                State <span className="icon-danger">*</span>
                              </h6>
                              <FormGroup>
                                <Select
                                  className="react-select react-select-default"
                                  classNamePrefix="react-select"
                                  name="colorSelect"
                                  options={allStates}
                                  value={state}
                                  onChange={(selected) => setState(selected)}
                                  placeholder="Select State"
                                />
                              </FormGroup>
                            </Col>
                            <Col md="6">
                              <h6>
                                City <span className="icon-danger">*</span>
                              </h6>
                              <Input
                                className="border-input"
                                defaultValue=""
                                placeholder="Enter city"
                                type="text"
                                value={city}
                                onChange={(event) =>
                                  setCity(event.target.value)
                                }
                              />
                            </Col>
                          </Row>
                          <Row className="price-row">
                            <Col md="6">
                              <h6>
                                Postal Code{" "}
                                <span className="icon-danger">*</span>
                              </h6>
                              <Input
                                className="border-input"
                                defaultValue=""
                                placeholder="Enter postal code"
                                type="text"
                                value={zip}
                                onChange={(event) => setZip(event.target.value)}
                              />
                            </Col>
                            <Col md="6">
                              <h6>
                                Amount <span className="icon-danger">*</span>
                              </h6>
                              <Input
                                className="border-input"
                                defaultValue=""
                                placeholder="Enter amount"
                                type="text"
                                value={amount}
                                onChange={(event) =>
                                  setAmount(event.target.value)
                                }
                              />
                            </Col>
                          </Row>
                          <div className="space-top"></div>
                          <Row>
                            <Col md="12" sm="12">
                              <Button
                                block
                                className="btn-round"
                                color="danger"
                                outline
                                onClick={submitHandler}
                                type="submit"
                              >
                                DONATE
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </Container>
                </div>
              </div>
            </Container>
          </div>
        </div>
      </div>
    </>
  );
};

export default Donate;
